<template>
	<section>

		<h3>
			FAQ
		</h3>

		<div class="row mt-4">
			<div class="col-md-12">
				<div class="d-flex justify-content-end align-items-end">

					<m-form-select
						:width="180"
						class="no-form-control me-2"
						label="Filter par catégorie"
						label-position="top"
						v-model="filterCategory"
						:items="fa_categories"
						@input="loadQuestions"
					/>
					<m-form-text
						class="ml-3 faq-search no-form-control"
						label="Rechercher"
						label-position="top"
						v-model="filterText"
						autocomplete
						@input="loadQuestions"
					/>
				</div>
			</div>	
		</div>

		<div v-show="rows_fa.length === 0" class="row mt-5">
			<div class="col-md-12 text-center">
				<h5>Aucun résultat trouvé</h5>
			</div>
		</div>

		<div class="row mt-4">

			<div class="col-md-12">

				<div v-for="(question, indexQuestion) in rows_fa" :key="indexQuestion">

					<h4 v-show="showQuestionCategory(indexQuestion)" class="category">
						{{ showQuestionCategory(indexQuestion) }}
					</h4>

					<ul>
						<li @click="scrollMeTo(`#${indexQuestion}`)" class="link">
							{{ question.fa_question }}
						</li>
					</ul>

				</div>
			</div>
		</div>

		<div class="row mt-5">
			<div class="col-md-12">

				<div v-for="(question, indexQuestion) in rows_fa" :key="indexQuestion">	
					<h4 v-show="showQuestionCategory(indexQuestion)" class="category mb-3">
						{{ showQuestionCategory(indexQuestion) }}
					</h4>
					<div :ref="`#${indexQuestion}`" class="rounded p-2 mb-5">
						<h5  class="question">
							{{ question.fa_question }}
						</h5>
						<div class="answer">
							<vue-marked>{{ question.fa_answer }}</vue-marked>
						</div>
						<div class="text-end">
							<div @click="scrollMeToTop" class="to-top">
								<icon style="fill: #0f8a98" name="arrow-up"/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>	

	</section>
</template>

<script>
import VueMarked from 'vue-marked';

export default {
	name: "faq",
	components: { 
		VueMarked
	 },
	data() {
		return {
			rows_fa: {},
			filterText: "",
			filterCategory: "",
			fa_categories: [{
				text: 'General',
				value: 0
			},{
				text: 'Administratif',
				value: 1
			},{
				text: 'Configuration',
				value: 2
			}]
		};
	},

	async mounted() {
		this.loadQuestions();
	},
	computed: {

	},
	methods: {

		scrollMeTo(refName) {
			const element = this.$refs[refName][0];
			element.classList.add("hightlight");
			window.scrollTo(0, element.offsetTop - 66);
			setTimeout(() => 
				element.classList.remove("hightlight"), 5000);
		},

		scrollMeToTop() {
			window.scrollTo(0, 0);
		},

		getQuestionCategory(value) {
			const result = this.fa_categories.find(status => status.value === value);
			return result ? result.text : "???";
		},

		showQuestionCategory(index) {
			const currentCategory = this.rows_fa[index].fa_category;
			if(index === 0) {
				return this.getQuestionCategory(currentCategory);
			} else {
				const prevCategory = this.rows_fa[index - 1].fa_category;
				if(currentCategory !== prevCategory) {
					return this.getQuestionCategory(currentCategory);
				} else {
					return undefined;
				}
			} 
		},

		async loadQuestions() {

			let params = {};

			if(this.filterText){
				params.search = this.filterText;
			}

			if(this.filterCategory !== undefined){
				params.category = this.filterCategory;
			}

			let response = await this.$axios.get(`${this.$config.server_url}/web/2.0/faq`, {params});

			this.rows_fa = response.data.data;
		}
	}
};
</script>

<style lang="scss">

	.category {
		font-size: 1.4rem;
	}

	.question {
		font-size: 1.1rem;
		font-weight: bold;
	}

	.to-top {
		display: inline-block;
		cursor: pointer;	
	}

	.link {
		color: #007bff;
		cursor: pointer;
	}

	.link:hover {
		text-decoration: underline;
	}

	.referral-code {
		display: inline-block;
		padding: 5px 10px;
		background-color: #F0F0F0;
		border: 1px solid #a0a0a0;
	}

	.hightlight {
  		animation: highlight-bg 3s ease-in;
	}

	@keyframes highlight-bg{
		0%{
			background:rgba(242, 242, 222, 1);
		}  
		20%{
			background:rgba(242, 242, 222, 0.8);
		}
		40% {
			background:rgba(242, 242, 222, 0.6);
		}
		60% {
			background:rgba(242, 242, 222, 0.4);
		}
		80% {
			background:rgba(242, 242, 222, 0.2);
		}
		100%{
			background:rgba(242, 242, 222, 0);
		}
	}

	.no-form-control {

		margin-top: 0 !important;

		input[name="search"] {
			margin-bottom: 0 !important;
		}
	}

	.v-select .vs__dropdown-toggle {
		border: var(--bs-border-width) solid var(--bs-border-color) !important;
		border-radius: var(--bs-border-radius);
		padding-bottom: 3px;
	}

	.faq-search .form-control {
		padding: 0.270rem 0.75rem;
	}



</style>
